import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';
import { creditWeiCost, smartContractAddress, availableEntryFees, baseURL } from '../util/Constants.js';

import { useGamesData } from '../hooks/useGamesData.js';
import { useContestData } from '../hooks/useContestData.js';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useGamerData } from '../hooks/useGamerData';

export const ViewSmartContractContest = (props) => {

  const { account, library } = useWeb3React();
  const gamerData = useGamerData( account );

  const [hasInit, setHasInit] = useState(false);
  const [myContract, setMyContract] = useState(null);

  const { data: contestContractData, mutate } = useSWR([smartContractAddress,'getContestStats', props.contestID], {
      fetcher: fetcher(library, GFCABI),
    })

  const contestData = useContestData(props.contestID);

  useEffect(() => {
    if(library && !hasInit){
      const contract = new Contract(smartContractAddress, GFCABI, library.getSigner());
      setMyContract(contract);
      setHasInit(true);
    }
    
  },[library])

  useEffect(() => {

      if(contestContractData){
          console.log(`contestContractData`, contestContractData);
      }

  },[contestContractData])

  const refreshEvents = () => {
 
    let fetchURL = `${baseURL}/checkContractEvents`;
  
    fetch(fetchURL,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((res) => {
          console.log('completed refreshEvents');
        })
    }

  const requestContestStatus = (contestID) => {
    console.log('requestContestStatus..');

    if(myContract !== null){
      console.log(myContract);
    
      myContract['requestContestStatus'](contestID)//, {gasLimit: '2000000' })
      .then(result => {
        console.log(`requestContestStatus attempted`);
      })
    
      
    }
  }


 
  const displayContest = () => {
    let display = null;
    let displayGamers = null;
    let smartContractDisplay = null;
    let contestDisplay = null;

    if(contestContractData){

        let entryFee = contestContractData[9].toNumber();
        let game = contestContractData[1];
        let displayGamers = contestContractData[2].map((gamerAddress) => {

            //Omit Empty Addresses
            if(gamerAddress === '0x0000000000000000000000000000000000000000'){
                return null;
            }

            return(
              <Typography variant="p">
              <p>{gamerAddress}</p>
              </Typography> 
            )
        })
        let maxPlayers = contestContractData[3].toNumber();
        let currentPlayers = contestContractData[4].toNumber();

        let winner = contestContractData[5];
        let score = contestContractData[6];
        let isComplete = contestContractData[7];
        let contestIDLocal = contestContractData[8];
        

        smartContractDisplay = (
            <Grid container>
            <Grid item xs>
            <p> {game} Contract Data: ({contestIDLocal}) </p> 
            <p> Players: {currentPlayers} / {maxPlayers} </p>
            </Grid>
            <Grid item xs>
            <Typography variant="h6">
              Contestants:
            </Typography> 

            {displayGamers}
            </Grid>
            
            </Grid>
        )
    }

    if(contestData.data){

      let displayParticipants = null;
      let displayParticipantsEntries = [];

      if(contestData.data.participants){

        for(let participant in contestData.data.participants){
          let _participantData = contestData.data.participants[participant];
          let _entry =  (
            <TableRow key={_participantData.gamerName}>
                          <TableCell align="left">
                          <Typography variant="p" style={{alignSelf: 'center'}}>
                          <p> {_participantData.gamerName} </p>
                          </Typography> 
                          </TableCell>
                          <TableCell align="left">
                          <Typography variant="p" style={{alignSelf: 'center'}}>
                          <p> {_participantData.score} </p>
                          </Typography> 
                          </TableCell>
                          <TableCell align="left">
                          <Typography variant="p" style={{alignSelf: 'center'}}>
                            <p> {_participantData.role} </p>
                          </Typography> 
                          </TableCell>
                          <TableCell align="left">
                          <Typography variant="p" style={{alignSelf: 'center'}}>
                            <p> {_participantData.status} </p>
                          </Typography> 
                          </TableCell>
                          <TableCell align="left">
                          <Button
                          variant={'outlined'}
                          onClick={() => {
                            console.log('Refresh Player Data');
                            refreshEvents()
                              //getContestIndex(contest.NO_ID_FIELD);
                              //handleSelectContest(contest.NO_ID_FIELD);
                              //attemptJoinContest(contest.NO_ID_FIELD);
                          }}
                          > Refresh </Button>
                           </TableCell>
              </TableRow>
          )
          displayParticipantsEntries.push(_entry);
        }

        
      }

      if(displayParticipantsEntries.length > 0){
        displayParticipants = (
        <React.Fragment>
          <Typography variant="h5" style={{alignSelf: 'center'}}>
            Contest Players
          </Typography>
          <TableContainer>
                <Table aria-label="simple table" style={{marginLeft: '5%', marginRight: '5%', maxWidth: '90%'}}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Gamer Name </TableCell>
                      <TableCell>Score </TableCell>
                      <TableCell>Role </TableCell>
                      <TableCell>Status </TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {displayParticipantsEntries}
                  </TableBody>
                </Table>
              </TableContainer>
          
          </React.Fragment>)
      }

      let tempData = contestData.data;

      let winner = null;
      
      if(tempData.winner && tempData.winner !== "notDetermined"){
        winner = tempData.winner;
      }

      let canClaim = false;

      if(winner && gamerData.hasGamerName){
        if(winner === gamerData.hasGamerName){
          canClaim = true;
        }
      }

      let claimButton = null;
      if(tempData.status === "pendingCompletion"){
      claimButton = (
        <Button
        onClick={() => {
          requestContestStatus(props.contestID);
        }}
        >
          Claim Winnings!
        </Button>
      )
      }

      let displayEntryLink = null;

      let gamerHash = gamerData.data.playerHash;

      if(tempData.game === "Snake"){
        displayEntryLink = (
          <a href={`https://gfc-snake.web.app/?gh=${gamerHash}`} target={'_blank'} style={{color: '#FFFFFF'}}> Open Snake In A New Window </a>
        )
      }

      contestDisplay = (
        <React.Fragment>
          <Typography variant="h5" style={{alignSelf: 'center'}}>
            <p> {tempData.game} Contest Details: </p>
            {displayEntryLink}
            {winner &&
            <p>Winner: {winner}!</p>
            }
            {canClaim &&
            <React.Fragment>
              {claimButton}
            </React.Fragment>
            }
            </Typography> 
        <Grid container>
            <Grid item xs>
            <Typography variant="h6">
            <p> Goal: {tempData.goalDesc}</p>
            </Typography> 
            <Typography variant="p" style={{alignSelf: 'center'}}>
            <p> Entry Cost: {tempData.entryFee} Credit </p>
            </Typography> 
            </Grid>
            <Grid item xs>
            <Typography variant="h6">
            <p> Host: {tempData.hostGamer}</p>
            </Typography> 
            <Typography variant="p" style={{alignSelf: 'center'}}>
            <p> Max Players: {tempData.maxPlayers} </p>
            </Typography> 
            </Grid>
            <Grid item xs={'12'}>
            {displayParticipants}
            </Grid>
            </Grid>
            
            </React.Fragment>
      )
    }

    if(smartContractDisplay){
      display = (
        <React.Fragment>
        {smartContractDisplay}
        {contestDisplay}
        </React.Fragment>
      )
    }

    
      return display;
  }

  return (
    <React.Fragment>

      <Typography variant="h5">
      Smart Contract Contest Data
      </Typography> 
      
      {displayContest()}
    </React.Fragment>
  )

}